import { surveysApi } from '../surveyApi';
import type { Survey } from '../surveyTypes';

/**
 * The three acts that move a survey through its run. ONE definition, read by the status card
 * and by the profile banner, so the two cannot word one act two ways.
 */
export type SurveyAct = 'start' | 'end' | 'reopen';

/** Each act's call, its dialog title, what it commits (said BEFORE the tick), and its toast. */
export const SURVEY_ACTS: Record<SurveyAct, { run: (id: string) => Promise<Survey>; title: string; consequence: string; done: string }> = {
  start: {
    run: surveysApi.start,
    title: 'Start survey',
    consequence: 'The survey opens: its questionnaire can be answered until it is ended.',
    done: 'Started the survey.',
  },
  end: {
    run: surveysApi.end,
    title: 'End survey',
    consequence:
      'The survey closes: its questionnaire can no longer be answered. The responses are kept, and the survey can be re-opened.',
    done: 'Ended the survey.',
  },
  reopen: {
    run: surveysApi.reopen,
    title: 'Re-open survey',
    consequence:
      'The survey opens again: its questionnaire can be answered until it is ended. The responses already given are kept.',
    done: 'Re-opened the survey.',
  },
};
